<template>
  <button
    type="button"
    :class="[
      'calculator__downloadButton',
      `calculator__downloadButton--${fileType}`,
      buttonClass,
      { 'calculator__downloadButton--loading': isLoading },
      {
        'calculator__downloadButton--disabled':
          downloadStore.active && downloadStore.activeType !== fileType,
      },
    ]"
    :disabled="downloadStore.active && downloadStore.activeType !== fileType"
    @click="handleDownload(fileType)"
  >
    <span v-if="isLoading" class="spinner"></span>

    <span v-else class="icon" v-html="svgIcon" aria-hidden="true" />
    {{ buttonText }}
  </button>
</template>

<script>
import downloadStore from '../../../utils/calculator-download-store'

export default {
  name: 'calculator-download-button',
  props: {
    fileType: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      required: true,
    },
    buttonClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isLoading: false,
      downloadStore,
    }
  },
  computed: {
    svgIcon() {
      switch (this.fileType) {
        case 'pdf':
          return `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M5 12V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H14L19 8V12" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M5 18H6.5C6.89782 18 7.27936 17.842 7.56066 17.5607C7.84196 17.2794 8 16.8978 8 16.5C8 16.1022 7.84196 15.7206 7.56066 15.4393C7.27936 15.158 6.89782 15 6.5 15H5V21" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M17 18H19" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M20 15H17V21" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M11 15V21H12C12.5304 21 13.0391 20.7893 13.4142 20.4142C13.7893 20.0391 14 19.5304 14 19V17C14 16.4696 13.7893 15.9609 13.4142 15.5858C13.0391 15.2107 12.5304 15 12 15H11Z" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>`
        case 'csv':
          return `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 3V7C14 7.26522 14.1054 7.51957 14.2929 7.70711C14.4804 7.89464 14.7348 8 15 8H19" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M17 21H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H14L19 8V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21Z" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8 11H16V18H8V11Z" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8 15H16" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M11 11V18" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>`
        case 'xlsx':
          return `
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M14 3v4a1 1 0 0 0 1 1h4"/><path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"/></svg>`
        default:
          return ''
      }
    },
  },
  methods: {
    handleDownload(fileType) {
      if (this.downloadStore.active) return

      this.isLoading = true
      this.downloadStore.start(fileType)
      this.pushGTM(fileType)

      const done = () => {
        this.isLoading = false
        this.downloadStore.finish()
      }

      this.$emit('download', fileType, done)
    },

    pushGTM(fileType) {
      window.dataLayer.push({
        event: 'file_download',
        file_extension: fileType,
      })
    },
  },
}
</script>

<style lang="scss">
.calculator__downloadButton {
  display: flex;
  align-items: center;
  flex-direction: row-reverse;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  font-size: 0.75rem;
  font-weight: 700;
  border-radius: 3.125rem;
  border: 0.125rem solid #77b883;
  color: #77b883;

  &:focus-visible {
    outline: 0.125rem solid #77b883;
    outline-offset: 0.125rem;
  }

  &--loading {
    background-color: #77b883;
    color: #fff;
  }

  &--disabled {
    opacity: 0.4;
    pointer-events: none;
    cursor: not-allowed;
  }
}

.icon,
.spinner {
  width: 1.25rem;
  height: 1.25rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.spinner {
  border: 0.125rem solid currentColor;
  border-top: 0.125rem solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.icon svg {
  width: 100%;
  height: 100%;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
</style>
